import PlanejamentoContratoFormFocoContrato from '../../../../produto/spa/planejamento-contrato/form/passo-geral/PlanejamentoContratoFormFocoContrato';

export default PlanejamentoContratoFormFocoContrato;
